var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"maintained"},[_c('van-nav-bar',{attrs:{"title":"功能关闭","left-text":"返回"},on:{"click-left":_vm.onClickLeft}}),_c('van-empty',{attrs:{"image":"error","description":"充值功能关闭"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }